<div class="packages-container">
	<div *ngFor="let pckg of packages" class="package-card-container package-card-container-{{ pckg.id }}"
		 (click)="selectPackage(pckg)" [ngClass]="{ 'selected': pckg.id === selectedPackage?.id }">
		<mat-card class="branding--select-package-card">
			<mat-card-content>
				<div class="branding--select-package-card--image branding--select-package-card--image--{{ pckg.id }}"></div>
				<div class="branding--select-package-card--label branding--select-package-card--label--{{ pckg.id }}">{{ pckg.label }}</div>
				<div class="branding--select-package-card--description branding--select-package-card--description--{{ pckg.id }}" *ngIf='pckg.description'>{{ pckg.description }}</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
